import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateAdminRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const PrivateAdminRoute: React.FC<PrivateAdminRouteProps> = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            localStorage.getItem('token') ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        }
    />
);

export default PrivateAdminRoute;
